// extracted by mini-css-extract-plugin
export default {"container":"Page404_container__EKuqz"};